import {
  MANAGE_WORDLIST_LOADER,
  RESET_ONBOARDING,
  SET_ALL_LANGUAGE,
  SET_ALL_WORDS,
  // SET_ISFREETRIAL,
  SET_ISLEADUSER,
  SET_IS_RESULT,
  SET_LANGUAGE_INFO,
  SET_LEARN_ABOUT,
  SET_LEARN_ABOUT_ANSWER,
  SET_LEARN_ABOUT_LOADING,
  SET_LEARN_ABOUT_TITLE,
  SET_LEARN_ABOUT_TYPE,
  SET_LOADER_RECOMMENDED,
  SET_STEPPER_STEP,
  SET_USERTYPE,
  SET_WORDSLIST,
  SET_WORD_RESULT,
  SET_GOAL,
  SET_EXPERIENCE,
  SET_EXAM_BAND,
  SET_PREFERENCE_TYPE,
  SET_PLACEMENT,
  SET_PLACEMENT_DONE,
  SET_ONBOARDING_NAME,
  SET_ONBOARDING_EMAIL,
  SET_ONBOARDING_GROUP,
  SET_GROUP_REVEAL,
} from '../types'

export interface PlacementExcerptState {
  tempUser: string
  storyId: string
  level: string
  levelDisplay: string
  passageIndex: number
  maxPassages: number
  audioUrl: string | null
  tokens: { word: string; dict_id: string | null; frequency: number | null; has_audio?: boolean }[]
}

interface IStoryState {
  languages: any
  learnAbout: string[]
  learnAboutLoading: boolean
  learnAboutType: string
  learnAboutTitle: any
  learnAboutAnswer: string
  languageInfo: any
  wordDetail: any
  wordResult: any
  is_result: boolean
  stepper_step: number
  tempUser: string
  preferenceType: string
  wordList_loader: boolean
  userType: string
  isFreeTrial: boolean
  isLeadUser: boolean
  loaderRecommended: boolean
  // test-first flow
  goal: string
  experience: '' | 'yes' | 'no'
  examBand: { band_id: string; label: string; vocab: number } | null
  placement: PlacementExcerptState | null
  placementDone: { convergedLevel: string; convergedLevelDisplay: string; passagesDone: number } | null
  // several questions per screen, revealed one at a time
  name: string
  /** The address the code was sent to. The name question sits after the gate
   *  and seeds itself from this, so it has to outlive GateStep's local state. */
  email: string
  group: string | null
  /** How many questions of the current group are visible (see the orchestrator) */
  groupReveal: number
}

const initialState: IStoryState = {
  languages: [],
  learnAbout: [],
  learnAboutLoading: false,
  learnAboutType: '',
  learnAboutTitle: null,
  learnAboutAnswer: '',
  languageInfo: null,
  wordDetail: null,
  wordResult: null,
  is_result: false,
  stepper_step: 1,
  tempUser: '',
  preferenceType: '',
  wordList_loader: false,
  userType: '',
  isFreeTrial: true,
  isLeadUser: false,
  loaderRecommended: false,
  goal: '',
  experience: '',
  examBand: null,
  placement: null,
  placementDone: null,
  name: '',
  email: '',
  group: null,
  groupReveal: 1,
}

export default function onBoardingReducer(state = initialState, action: any) {
  switch (action.type) {
    case SET_LEARN_ABOUT:
      return {
        ...state,
        learnAbout: action?.payload || [],
      }
    case SET_LEARN_ABOUT_LOADING:
      return {
        ...state,
        learnAboutLoading: action?.payload || false,
      }
    case SET_LEARN_ABOUT_TYPE:
      return {
        ...state,
        learnAboutType: action?.payload || '',
      }
    case SET_LEARN_ABOUT_TITLE:
      return {
        ...state,
        learnAboutTitle: action?.payload || null,
      }
    case SET_LEARN_ABOUT_ANSWER:
      return {
        ...state,
        learnAboutAnswer: action?.payload || '',
      }
    case SET_ALL_LANGUAGE:
      return {
        ...state,
        languages: action?.payload,
      }
    case SET_LANGUAGE_INFO:
      return {
        ...state,
        languageInfo: action?.payload,
      }
    case SET_ALL_WORDS:
      return {
        ...state,
        wordDetail: action?.payload?.wordList,
        tempUser: action?.payload?.wordList?.tempUser,
        preferenceType: action?.payload?.preferenceType,
      }
    case SET_WORDSLIST:
      return {
        ...state,
        wordDetail: {
          ...state.wordDetail,
          wordList: action?.payload,
          tempUser: action?.payload?.tempUser,
        },
      }
    case SET_WORD_RESULT:
      return {
        ...state,
        wordResult: action?.payload,
        wordList: [],
      }
    case SET_IS_RESULT:
      return {
        ...state,
        is_result: action?.payload,
      }
    case SET_STEPPER_STEP:
      // Legacy action (still dispatched by ChooseLanguage): payload 1 means
      // "restart the flow" in the old numbering — reset the group key too.
      return {
        ...state,
        stepper_step: action?.payload,
        ...(action?.payload === 1 ? { group: null, groupReveal: 1 } : {}),
      }
    case SET_GOAL:
      return {
        ...state,
        goal: action?.payload || '',
      }
    case SET_ONBOARDING_NAME:
      return {
        ...state,
        name: action?.payload || '',
      }
    case SET_ONBOARDING_EMAIL:
      return {
        ...state,
        email: action?.payload || '',
      }
    case SET_ONBOARDING_GROUP:
      return {
        ...state,
        group: action?.payload,
        // A group change always restarts the reveal at its first question
        groupReveal: 1,
      }
    case SET_GROUP_REVEAL:
      return {
        ...state,
        groupReveal: action?.payload || 1,
      }
    case SET_EXPERIENCE:
      return {
        ...state,
        experience: action?.payload || '',
      }
    case SET_EXAM_BAND:
      return {
        ...state,
        examBand: action?.payload || null,
      }
    case SET_PREFERENCE_TYPE:
      return {
        ...state,
        preferenceType: action?.payload || '',
      }
    case SET_PLACEMENT:
      return {
        ...state,
        placement: action?.payload || null,
        tempUser: action?.payload?.tempUser || state.tempUser,
      }
    case SET_PLACEMENT_DONE:
      return {
        ...state,
        placementDone: action?.payload || null,
      }
    case RESET_ONBOARDING:
      return {
        ...initialState,
      }
    case SET_USERTYPE:
      return {
        ...state,
        userType: action?.payload,
      }
    case MANAGE_WORDLIST_LOADER:
      return {
        ...state,
        wordList_loader: action?.payload,
      }
    // case SET_ISFREETRIAL:
    //   return {
    //     ...state,
    //     isFreeTrial: action?.payload,
    //   }
    case SET_ISLEADUSER:
      return {
        ...state,
        isLeadUser: action?.payload,
      }
    case SET_LOADER_RECOMMENDED:
      return {
        ...state,
        loaderRecommended: action?.payload,
      }
    default:
      return state
  }
}
